import { APIClient } from "api/api_helper";
import { ICARD_LABEL_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";
const api = new APIClient();

export const IdcardApiService = {
    // INSERT SUBJECT IDCARD HISTORY
    insertHistory: (payload_data: any) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            studyid: payload_data.studyid,
            printby: user?.userid,
            verifiedby: null,
            createdby: user?.userid,
            reasonforreprint: payload_data.reasonforreprint ? parseInt(payload_data.reasonforreprint, 10) : null,
            additionalcomments: payload_data.additionalcomments || null,
            printcount: payload_data.printcount || 1,
            jsondata: payload_data.jsondata || [],
        };
        return api.create(ICARD_LABEL_API.SUBJECT_ID_CARD_HISTORY_API + "Insert", payload);
    },
};